import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { StyledWrapperAbout } from "./styled";
import { FaArrowRight } from "react-icons/fa";
import { BiCalendarCheck } from "react-icons/bi";
import Container from "react-bootstrap/Container";

function About() {
  return (
    
      <StyledWrapperAbout>
        <Col xs={12} sm={12} md={12} lg={12}>
          <Row>
            <Col xs={12} sm={12} md={12} lg={9} className="numbers">
              <div
                style={{
                  background: "#354052",
                  display: "flex",
                  color: "white",
                  justifyContent: "flex-start",
                  width: "158px",
                  height: "53px",
                  alignItems: "center",
                  padding: "5px 14px",
                }}
              >
                <p
                  style={{
                    marginBottom: "0",
                    fontSize: "20px",
                    lineHeight: "24px",
                    fontWeight: "bold",
                  }}
                >
                  <a href="https://chequeado.com/latamchequea2022">
                    <span
                      role="img"
                      aria-label="ee_uu"
                      style={{
                        paddingRight: "9px",
                      }}
                    >
                      <img
                        src="https://flagcdn.com/16x12/es.png"
                        srcset="https://flagcdn.com/32x24/es.png 2x,https://flagcdn.com/48x36/es.png 3x"
                        width="16"
                        height="12"
                        alt="Spain"
                      ></img>
                    </span>
                    ES
                  </a>
                </p>
                <p
                  style={{
                    marginBottom: "0",
                    fontSize: "20px",
                    lineHeight: "24px",
                    fontWeight: "bold",
                  }}
                >
                  <a href="https://chequeado.com/latamchequea2022-en">
                    <span
                      role="img"
                      aria-label="spain"
                      style={{
                        paddingLeft: "9px",
                        paddingRight: "9px"
                      }}
                    >
                      <img
                        src="https://flagcdn.com/16x12/gb.png"
                        width="16"
                        height="12"
                        alt="Spain"
                      ></img>
                    </span>
                    EN
                  </a>
                </p>
              </div>
              <Row>
                <Col
                  lg={6}
                  style={{ padding: "170px 15px" }}
                >
                  <div
                    style={{
                      background: "white",
                      padding: "40px",
                      color: "#000",
                    }}
                  >
                    <h2 style={{ fontWeight: "bold" }}>LatamChequea 2022</h2>
                    <p className="text">
                    On October 6 and 7, 2022, Latin American fact-checkers will meet again for the fourth LatamChequea in-person summit, to be held for the first time in Bogotá, Colombia. The event, organized by Chequeado, ColombiaCheck and La Silla Vacía, aims to share common learning experiences and challenges among journalists and experts in the region.

                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col
              lg={3}
              xs={12} sm={12} md={12}
              className="primercontainer"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "0",
                paddingBottom: "0",
              }}
            >
              <div className="ubicacion">
                <Row>
                  <Col sm={12} md={12} lg={12}>
                    <BiCalendarCheck style={{ color: "white" }} size={60} />
                  </Col>
                </Row>
                <Row className="info"
                >
                  <Col sm={12} md={12} lg={12}>
                    <span>
                      <b>
                        06-07 <br /> OCT
                      </b>
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <p
                      style={{
                        marginTop: "80",
                        fontSize: "20px",
                        lineHeight: "24px",
                        fontWeight: "bold",
                        color: "#F4F4F4",
                        marginBottom: "40px",
                      }}
                    >
                      Bogotá, Colombia
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={8} md={8} lg={8} className="mx-auto">
                    <Row>
                      {/* <Col
                      lg={9}
                      xs={9}
                      sm={9}
                      md={9}
                      className="names"
                      style={{
                        background: "rgb(244, 244, 244)",
                        height: "30px",
                      }}
                    >
                      <p style={{marginBottom: "0", fontWeight: "bold", paddingTop: "3px"}}><a href="/#" className="inscribirse">Registrarse</a></p>
                    </Col> 
                    <Col
                      xs={3}
                      sm={3}
                      md={3}
                      lg={3}
                      style={{
                        background: "#e63457",
                        height: "30px",
                        paddingLeft: "0px",
                        paddingRight: "0px",
                      }}
                    >
                      <div
                        className="ir-link"
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <button className="golink">
                          <a
                            href="https://reversoar.com/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <FaArrowRight size={20} />
                          </a>
                        </button>
                      </div>
                    </Col>*/}
                    </Row>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Col>
      </StyledWrapperAbout>
  );
}

export default About;
